var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m436 512h-420c-8.284 0-15-6.716-15-15v-482c0-8.284 6.716-15 15-15h60c8.284 0 15 6.716 15 15v10c0 8.271 6.729 15 15 15s15-6.729 15-15v-10c0-8.284 6.716-15 15-15h60c8.284 0 15 6.716 15 15v10c0 8.271 6.729 15 15 15s15-6.729 15-15v-10c0-8.284 6.716-15 15-15h60c8.284 0 15 6.716 15 15v10c0 8.271 6.729 15 15 15s15-6.729 15-15v-10c0-8.284 6.716-15 15-15h60c8.284 0 15 6.716 15 15v482c0 8.284-6.716 15-15 15z",
    fill: "#ffe278"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m436 0h-60c-8.284 0-15 6.716-15 15v10c0 8.271-6.729 15-15 15s-15-6.729-15-15v-10c0-8.284-6.716-15-15-15h-60c-8.284 0-15 6.716-15 15v10c0 8.271-6.729 15-15 15v472h210c8.284 0 15-6.716 15-15v-482c0-8.284-6.716-15-15-15z",
    fill: "#ffd845"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m376 152h-300c-8.284 0-15-6.716-15-15s6.716-15 15-15h300c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#556e82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m376 212h-300c-8.284 0-15-6.716-15-15s6.716-15 15-15h300c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#556e82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m306 272h-230c-8.284 0-15-6.716-15-15s6.716-15 15-15h230c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#556e82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 332h-180c-8.284 0-15-6.716-15-15s6.716-15 15-15h180c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#556e82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m211 392h-135c-8.284 0-15-6.716-15-15s6.716-15 15-15h135c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#556e82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m253 452h-177c-8.284 0-15-6.716-15-15s6.716-15 15-15h177z",
    fill: "#556e82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#3c4655"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m391 137c0-8.284-6.716-15-15-15h-150v30h150c8.284 0 15-6.716 15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 182h-150v30h150c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306 272c8.284 0 15-6.716 15-15s-6.716-15-15-15h-80v30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 332c8.284 0 15-6.716 15-15s-6.716-15-15-15h-30v30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 422h27v30h-27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m474.787 247.052-31.819-31.819c-5.858-5.858-15.355-5.858-21.213 0l-159.896 159.894c-5.858 5.858-5.858 15.355 0 21.213l31.82 31.82c5.858 5.858 15.355 5.858 21.213 0l159.895-159.895c5.858-5.858 5.858-15.355 0-21.213z",
    fill: "#6ba7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.859 375.128c-1.5 1.5-2.665 3.302-3.418 5.286l-19.446 51.267c-2.094 5.519-.755 11.753 3.418 15.926 4.174 4.174 10.408 5.512 15.926 3.418l51.266-19.446c1.985-.753 3.787-1.918 5.287-3.419z",
    fill: "#fabe8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.607 215.232-31.819-31.819c-5.858-5.858-15.355-5.858-21.213 0l-31.82 31.819 53.033 53.032 31.819-31.819c5.857-5.857 5.857-15.355 0-21.213z",
    fill: "#ff3838"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.8286c98d6e1d843bd6be498b3a2c81b9.svg";
export { ForwardRef as ReactComponent };